import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectAIModuleFeatureEnable } from 'store/currentUser/currentUserSelectors';
// Components
import GenerateTranslationsDialog from 'dialogs/GenerateTranslations.dialog';
import { Checkbox } from 'components/Controls';
import { Button } from 'components/Buttons';
// Icons
import { BsStars } from "react-icons/bs";

type Props = {
  country: { label:string; value:string };
  checked: boolean;
  handleAdditionalLanguages: (lng:string) => void;
}

const AdditionalLanguageItem:FC<Props> = ({ country, checked, handleAdditionalLanguages }) => {
  const { t } = useTranslation();

  const aiModuleFeatureEnable = useAppSelector(selectAIModuleFeatureEnable);

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      {open ? (
        <GenerateTranslationsDialog open={open} onClose={toggle} language={country.value} />
      ) : null}

      <div className="flex items-center gap-2">
        <Checkbox
          id={`language-${country.value}`}
          name={`language-${country.value}`}
          label={country.label}
          checked={checked}
          onChange={() => handleAdditionalLanguages(country.value)}
        />
        {aiModuleFeatureEnable && checked ? (
          <Button
            size="xs"
            variant="contained"
            className="p-1 mb-3"
            onClick={toggle}
          >
            <div className="flex items-center gap-1">
              <BsStars fontSize="16px" />
              <span>{t('buttons.aiTranslate')}</span>
            </div>
          </Button>
        ) : null}
      </div>
    </Fragment>
    
  )
}

export default AdditionalLanguageItem;
